import {
  Drawer as MantineDrawer,
  DrawerProps as MantineDrawerProps,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { ReactNode, useEffect, useState } from 'react';

interface DrawerProps extends Omit<MantineDrawerProps, 'opened'> {
  children: ReactNode;
  opened: boolean;
  onClose: () => void;
}

export default function Drawer({
  children,
  opened,
  onClose,
  ...props
}: DrawerProps) {
  const isMobile = useMediaQuery('(max-width: 50em)');

  const [mounted, setMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  /* eslint-disable react-hooks/set-state-in-effect -- drives mount/visible animation sequence from the opened prop */
  useEffect(() => {
    if (opened) {
      setMounted(true);

      const openTimer = setTimeout(() => {
        setIsVisible(true);
      }, 10);

      return () => clearTimeout(openTimer);
    } else {
      setIsVisible(false);

      const closeTimer = setTimeout(() => {
        setMounted(false);
      }, 300);

      return () => clearTimeout(closeTimer);
    }
  }, [opened]);
  /* eslint-enable react-hooks/set-state-in-effect */

  const handleClose = () => {
    onClose();
  };

  if (!mounted) return null;

  return (
    <MantineDrawer
      position="right"
      size={isMobile ? '100%' : '40%'}
      shadow="md"
      opened={isVisible}
      onClose={handleClose}
      transitionProps={{ duration: 300 }}
      {...props}
      styles={{
        title: {
          fontWeight: 500,
        },
        header: {
          borderBottom: '1px solid var(--mantine-color-gray-2)',
        },
        body: {
          padding: 0,
        },
        ...props.styles,
      }}
    >
      {children}
    </MantineDrawer>
  );
}
